// @flow

export default {
  END_OF_LIFE: 3,
  END_OF_SALE: 4
};
